module.exports = __webpack_public_path__ + "img/menu.62874c63.svg";